import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import * as Yup from 'yup'
import { Field, ErrorMessage } from 'formik'
import { StepForm } from 'forms'
import { DocumentUploads } from 'components'
import { STEP, TAX_DOCUMENT_FILE_PREFIX } from 'config'

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
}

const defaultProps = {}

const validationSchema = Yup.object({
  taxDocument: Yup.object({
    files: Yup.array(),
    x1040NotAvailable: Yup.string(),
  }).test(
    'oneRequired',
    'Please upload your 1040 or provide an explanation for why it is unavailable.',
    (value) => {
      const hasFiles = value?.files && value.files.length > 0
      const hasExplanation =
        value?.x1040NotAvailable && value.x1040NotAvailable.trim().length > 0
      return hasFiles || hasExplanation
    }
  ),
})

function TaxDocumentForm({ onSubmit, initialValues }) {
  return (
    <StepForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      previousStep={STEP.STUDENT_STATUS}
      validationSchema={validationSchema}
    >
      <div className="document-section">
        <div className="tax-document-upload">
          <h2>1040 Tax Return</h2>
          <p>
            Please upload your most recently filed 1040 tax return. If you did
            not file or are unable to provide a copy, explain why in the field
            below.
          </p>
          <DocumentUploads
            name={`taxDocument.files`}
            uploadDetails={{
              uploadHeader: '1040 Tax Return',
              uploadSubHeader:
                'Upload a copy of your most recently filed federal 1040 tax return.',
            }}
            hideMainHeading
          />
        </div>

        <div className="bottom-border" />

        <div className="tax-document-explanation">
          <h2>Unable to Provide a 1040?</h2>
          <p>
            If you are unable to upload a 1040 (e.g., you did not file taxes
            last year or do not have a copy), please explain below.
          </p>
          <label htmlFor="taxDocument.x1040NotAvailable" className="form-label">
            Explanation
          </label>
          <Field
            as="textarea"
            id="taxDocument.x1040NotAvailable"
            name="taxDocument.x1040NotAvailable"
            className="form-control"
            rows={4}
            placeholder="Please explain why you are unable to provide a 1040 tax return..."
          />
        </div>

        <ErrorMessage
          name="taxDocument"
          render={(msg) =>
            typeof msg === 'string' ? (
              <p className="error-message" style={{ color: 'red', marginTop: '1rem' }}>
                {msg}
              </p>
            ) : null
          }
        />
      </div>
    </StepForm>
  )
}

TaxDocumentForm.propTypes = exact(propTypes)
TaxDocumentForm.defaultProps = defaultProps

export default React.memo(TaxDocumentForm)
